// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___QJFQ","question":"styles_question__kydvv","description":"styles_description__1SH-a"};